export var DataCatalogTagSource;
(function (DataCatalogTagSource) {
    DataCatalogTagSource["DATA_CATALOG_TAG_SOURCE_DIRECT"] = "DIRECT";
    DataCatalogTagSource["DATA_CATALOG_TAG_SOURCE_INHERITED"] = "INHERITED";
})(DataCatalogTagSource || (DataCatalogTagSource = {}));
